export const getPathTransaction =(transactionList, { transactionId: pathId }) => {
    const [transactionId, combinationId = null] = pathId.split("-");
    let transaction;

    if(transactionList && transactionList.length === 1) {
        return transactionList[0];
    } else {
        transaction = transactionList.find((transaction) => {
            if (combinationId) {
                return transaction.transactionId === parseInt(transactionId)
                    && transaction.multiCouponCombinationDetails.find((c) => c.combinationId === parseInt(combinationId))
            }
            return transaction['transactionId'] === parseInt(transactionId);
        });
        return transaction;
    }
}